/* eslint-disable import/prefer-default-export */

import * as api from '../../../../common/api';

export function fetchOrganizations() {
  return (dispatch, getState) => {
    if (getState().organizations.length) return;

    const promise = async () => {
      const response = await api.get('/organizations');

      return response.json();
    };

    dispatch({
      type: 'FETCH_ORGANIZATIONS',
      payload: promise()
    });
  };
}



// WEBPACK FOOTER //
// ./src/browser/Feature/components/team_section/actions.js